
// import { v4 as uuid } from 'uuid';
import { ICorrelation } from '../ViewModel/Utilities';


export class Mutex {

    constructor(name: string) {
        this._name = name;
    }

    private internalLock<T>(fn: () => Promise<T>, options?: { correlation?: ICorrelation, operation?: string }) {

        if (!this.mutex) {
            this.mutex = Promise.resolve();
        }

        // Chain the function onto the mutex promise
        const result = this.mutex
            .then(() => fn())
            .catch((e) => {
                console.error(`${(new Date()).toISOString()} > Error in ${this._name}${options?.operation ? ` | ${options?.operation}` : ''}:\n\n`);
                console.error(e);
                return null;
            });

        // Update the mutex to be resolved once the function has been processed
        this.mutex = result.then(() => undefined); // Ensures that this.mutex remains a Promise<void>

        // Return the result of the passed-in function
        return result;

    }

    lock<T>(fn: () => Promise<T>, options?: { correlation?: ICorrelation, operation?: string }) {

        if (this.isSingle) {
            throw new Error('Cannot lock a single mutex while a single mutex is already locked');
        }

        return this.internalLock(fn, options);
    }

    lockSingle<T>(fn: () => Promise<T>, options?: { correlation?: ICorrelation, operation?: string }) {

        if (this.mutex) {
            return null;
        }

        this.isSingle = true;
        let retVal = this.internalLock(fn, options);

        retVal.then(() => {
            this.mutex = undefined;
            this.isSingle = false;
        });
        return retVal;
    }

    private isSingle = false;
    private mutex: Promise<void> | undefined = undefined;
    private _name: string;
}
